<template>
    <div class="favorite-details">
        <div class="favorite-product">
            <div v-show="!!favorite.product" class="image-container">
                <Media
                    v-if="favorite?.product?.thumbnailImageUrl"
                    v-bind="favoriteImageMediaProps"
                />
            </div>
            <h4 v-show="!!favorite.product">
                {{ favorite?.product?.name }}
            </h4>
            <div v-show="!favorite.product" class="skeleton-img">
            </div>
            <div v-show="!favorite.product" class="skeleton">
                
            </div>

        </div>
        <div class="ctas">
            <RothcoCta ref="product_link" id="product_link" class="primary" :href="favorite?.product?.seo_name ? route('productDetail.show', [favorite?.product?.seo_name]) : '#'">
                View Product
            </RothcoCta>
            <button id="delete_button" 
                class="secondary" 
                @click="removeFavorite()">
                    <DeleteBlackIcon class="secondary" style="margin:0;"/>
            </button>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import Media from "./Media.vue";
    import RothcoCta from "./RothcoCta.vue";
    import productVariantSwatches from "@/helpers/composables/productVariantSwatches.ts";
    import DeleteBlackIcon from "@icons/delete-black.svg";
    import {
        parseProductUploadImageFilename,
        productUploadImageResponsiveFromFilename,
        PRODUCT_IMAGE_SIZES_FAVORITES
    } from "@/helpers/productUploadImageUrl";
    let props = defineProps({
        favorite: {
            type: Object,
            default(){
                return {
                    product: {}
                }
            }
        }
    })

    let route = inject("route");

    let { productVariants } = productVariantSwatches();
    let variants = computed(()=>{
        return productVariants(props.favorite.product.variants);
    });

    const favoriteImageMediaProps = computed(() => {
        const url = props.favorite?.product?.thumbnailImageUrl ?? "";
        if (!url) {
            return { media: "", defaultMediaType: "image" as const };
        }
        const filename = parseProductUploadImageFilename(url);
        if (!filename) {
            return {
                media: url,
                defaultMediaType: "image" as const,
                alt: props.favorite?.product?.name
                    ? `Image of ${props.favorite.product.name}`
                    : ""
            };
        }
        const { src, srcSet, sizes } = productUploadImageResponsiveFromFilename(
            filename,
            PRODUCT_IMAGE_SIZES_FAVORITES
        );
        return {
            media: src,
            srcSet,
            sizes,
            defaultMediaType: "image" as const,
            alt: props.favorite?.product?.name
                ? `Image of ${props.favorite.product.name}`
                : ""
        };
    });

    const emit = defineEmits(["removeFavorite"]);
    const removeFavorite = ()=>{
        emit('removeFavorite', props.favorite.favorite_id)
    }
</script>